/*
  "Add to cart · total" (feature 011, specs/011-product-page-redesign/research.md R9).
  total = (variant price + ticked gift price) × quantity, formatted with the shop's money format.
  The server renders the variant price, so the button is correct without JavaScript.
*/
(() => {
  const money = (cents, format) => {
    const group = (decimals, thousands, point) => {
      const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? point + fraction : '');
    };
    const forms = {
      amount: () => group(2, ',', '.'),
      amount_no_decimals: () => group(0, ',', '.'),
      amount_with_comma_separator: () => group(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => group(0, '.', ','),
    };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => (forms[key] ? forms[key]() : match));
  };

  const init = (wrap) => {
    const form = wrap.closest('product-form');
    // getAttribute: the form has an <input name="id">, so form.id would return that input
    const formId = form && form.querySelector('form') ? form.querySelector('form').getAttribute('id') : null;
    const output = wrap.querySelector('[data-product-total]');
    const sectionRoot = wrap.closest('product-info') || document;
    let unit = Number(wrap.dataset.unitPrice) || 0;
    const quantityInput = () => (formId && document.querySelector(`input[name="quantity"][form="${formId}"]`)) || null;
    const gift = () => sectionRoot.querySelector('[data-gift-checkbox]');
    const update = () => {
      const quantity = Math.max(1, parseInt((quantityInput() || {}).value, 10) || 1);
      const box = gift();
      const extra = box && box.checked ? Number(box.dataset.price) || 0 : 0;
      output.textContent = money((unit + extra) * quantity, wrap.dataset.moneyFormat);
    };
    document.addEventListener('change', (event) => {
      if (event.target === quantityInput() || event.target === gift()) update();
    });
    document.addEventListener('input', (event) => { if (event.target === quantityInput()) update(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data && data.variant && sectionRoot.contains(wrap)) { unit = data.variant.price; update(); }
      });
    }
    update();
  };

  const run = () => document.querySelectorAll('[data-product-total-wrap]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
